import * as React from 'react'
import { FormControls } from '../../../../Shared/Frontend/forms'
import { SearchBarProps, SearchButtonProps, SearchFormProps } from './searchBar.state'
import { SharedBlockLayout } from '../modernBlocks/blocks/shared/sharedBlock.layout'
import i18next from 'i18next'

export const SearchFormLayout = (props: SearchFormProps) => (
  <form
    className='searchform__form'
    onSubmit={e => {
      e.preventDefault()
      if (props.submitSearchValue) return props.submitSearchValue()

      window.location.href = `/${window.location.href.includes("/wp/") ? "wp" : ""}/zoeken?searchQuery=${props.searchValue}`
        .replace(/\/\//g, "/")
        .replace(/\/\//g, "/")
    }}
  >
    <label className='sr-text' htmlFor="search-input">{props.label}</label>
    <FormControls.FormItemWithID
      key="search-input"
      controlId="search-input"
      type='search'
      inputMode='text'
      disabled={false}
      required={false}
      value={props.searchValue}
      label={props.label}
      placeholder={i18next.t('Search:Placeholder')}
      onChange={e => props.updateSearchValue(e.valueOf())}
    />
    
    <button className="searchform__submit" type="submit">
      <span className="sr-text">Zoeken</span>
      <SharedBlockLayout.SVGIcon iconId='#icon--search' width='24px' height='24px' className="searchform__icon" />
    </button>
  </form>
)

export const SearchButtonLayout = (props: SearchButtonProps) => {
  return (
    <li className={`sh__extra-item sh__extra-item--search ${props.display == 'desktop' ? '' : "sh__nav-item"}`} key="dk-e-s">
      <a className={`sh__extra-link sh__extra-link--search ${props.show === true ? 'active' : ''} ${props.display == 'desktop' ? '' : "sh__nav-link link"}`} href="/zoeken">
        <span className={props.display == 'desktop' ? "sr-text" : "link__label" }>Zoeken</span>
        <svg className="link__icon" width="24px" height="24px" aria-hidden="true"><use xlinkHref="#icon--search" /></svg>
      </a>
    </li>
  )
}

export const SearchBarLayout = (props: SearchBarProps) => {
  return (
    <></>
  )
}
